import { render, staticRenderFns } from "./compare-table.vue?vue&type=template&id=175b7727&scoped=true"
import script from "./compare-table.vue?vue&type=script&lang=js"
export * from "./compare-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b7727",
  null
  
)

export default component.exports